<script lang="ts">
  import { IntersectionObserver } from "@opera-gx/components/v6";
  import { get } from "svelte/store";
  import { writable } from "svelte/store";
  // prettier-ignore
  import { fade, fly } from "svelte/transition";

  import Image from "../components/Image.svelte";
  import ShowMore from "../components/ShowMore/ShowMore.svelte";
  import Tile from "../components/Tile/Tile.svelte";
  import { country, language } from "../store/language";
  import { oldTheme } from "../store/theme";
  import { themeConfig } from "../themes/themeConfig";
  import EnebaSection from "./EnebaSection.svelte";
  export let component;
  export let items;
  export let section_title: string;
  export let id;
  export let key = "";
  export let infinite = false;
  let showMoreIntersecting = false;
  let showMore = writable(false);
  const limit = 4;
</script>

{#if items}
  <section
    id={key !== "" ? `gx-section_${key}` : null}
    class="pl-left pr-right flex flex-col gap-4">
    <h2
      class="mb-4 text-lg font-semibold"
      style="color: hsl(var(--color-gxm-text-on-wallpaper));">
      {section_title}
    </h2>
    <div
      transition:fade
      class="grid grid-cols-2 grid-rows-1 gap-4 sm:grid-cols-3 md:grid-cols-4">
      {#if items.length > 0}
        {#each $showMore ? items : items.slice(0, limit) as deal, index}
          {@const tag = deal?.tag ?? items[1][0] ?? null}
          {@const subTag = deal?.subTag ?? items[1][1] ?? null}
          {#if deal?.game}
            <div
              class="aspect-[3/4] w-auto transition-all duration-700"
              style="transition-delay: {40 * index}ms;">
              <IntersectionObserver once={true} let:intersecting>
                {#if intersecting}
                  <Tile let:class={tile}>
                    <a
                      href="/game?id={id}&gameId={deal?.game
                        ?.id}&offertId={deal?.id}&component={component}&country={country()}&lang={get(
                        language,
                      )}&colors={JSON.stringify(window?.oprt?.gxCornerConfig?.colors) ||
                        ''}&theme={$themeConfig?.theme || $oldTheme}"
                      class="{tile} to-accent/40 after:to-accent relative block aspect-[3/4] bg-gradient-to-br from-transparent bg-cover bg-center bg-no-repeat after:bg-gradient-to-br after:from-transparent after:via-transparent"
                      target="_blank"
                      transition:fly
                      class:-translate-x-3={!intersecting}>
                      <Image
                        src={deal.game.imageCoverVertical?.url}
                        h={229}
                        w={192}
                        alt={deal?.game.title} />

                      {#if deal.store}
                        <div
                          style="background-color: {deal.store
                            ?.color}; display: flex; align-items: center; padding-left: 2px; padding-right: 2px;"
                          class="bg-accent text-shadow absolute right-4 top-0 h-7 w-5 rounded-b text-white">
                          <img src={deal?.store?.icon?.url} alt="Store img" />
                        </div>
                      {/if}
                      {#if deal.genre}
                        <div
                          style="background-color: black; display: flex; align-items: center; padding-left: 2px; padding-right: 2px;"
                          class="bg-accent text-shadow absolute right-4 top-0 h-7 w-5 rounded-b text-white">
                          <img src={deal?.genre?.icon?.url} alt="Store img" />
                        </div>
                      {/if}
                      <div
                        class="text-shadow absolute bottom-2 left-2 flex w-full flex-col items-start gap-1 text-white">
                        <div class="w-11/12 truncate text-sm font-semibold leading-none">
                          {deal?.game.title}
                        </div>
                        {#if deal.platforms.length > 0}
                          <div class="flex flex-row gap-1">
                            {#each deal.platforms as platform}
                              <img
                                src={platform?.icon?.url}
                                alt="platform"
                                class="h-4 w-4 rounded-full bg-[#CFCFCF] text-[#131019]" />
                            {/each}
                          </div>
                        {:else if deal?.game.platforms}
                          <div class="flex flex-row gap-1">
                            {#each deal.game.platforms as platform}
                              <img
                                src={platform?.icon?.url}
                                alt="platform"
                                class="h-4 w-4 rounded-full bg-[#CFCFCF] text-[#131019]" />
                            {/each}
                          </div>
                        {/if}
                        {#if tag}
                          <div class="flex flex-row items-center gap-1">
                            <div
                              class="bg-accent text-2xs rounded px-1.5 py-1 font-bold uppercase italic"
                              style="background-color: hsl(var(--color-accent));">
                              {tag.name}
                            </div>
                            {#if subTag}
                              <div>
                                <div class="text-2xs italic">
                                  {subTag.name}
                                </div>
                              </div>
                            {/if}
                          </div>
                        {/if}
                        <div class="flex flex-row items-center gap-1">
                          {#if deal?.game?.prices && deal?.game?.prices?.length !== 0}
                            <div
                              class="bg-accent text-2xs rounded px-1.5 py-1 font-bold uppercase italic">
                              -{deal?.game?.prices[0].discount}%
                            </div>
                            <div class="text-xs font-semibold uppercase">
                              {deal?.game?.prices[0].price}
                              {deal?.game?.prices[0].currency.abbr}
                            </div>
                          {/if}
                        </div>
                      </div>
                    </a>
                  </Tile>
                {/if}
              </IntersectionObserver>
            </div>
          {:else}
            <EnebaSection {deal} {index} />
          {/if}
        {/each}
      {/if}
    </div>
    {#if items.length > limit && !infinite}
      <ShowMore {showMore} {showMoreIntersecting} {section_title} />
    {/if}
  </section>
{/if}
